import axios from "./axiosClient";

export const fetchData = async (method, url, data = null, config = null) => {
  try {
    let response;

    if (method === 'GET') {
      response = await axios.get(url, { params: data });
    } else if (method === 'POST') {
      response = await axios.post(url, data, config);
    } else if (method === 'PUT') {
      response = await axios.put(url, data);
    } else if (method === 'DELETE') {
      response = await axios.delete(url, { data });
    } else {
      throw new Error(`Unsupported method: ${method}`);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
}
